import React, { useEffect, useState, useRef } from 'react';
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import Icon1 from '@/assets/background/svg/group2_1.png';
import Icon2 from '@/assets/background/svg/group2_2.png';
import Icon3 from '@/assets/background/svg/group2_3.png';
import styles from './index.less';

/** 统计看板 */
export default ({ callback =()=> {}, }) => {
  const [swiper, setSwiper] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const tabSwiperRef = useRef(null);

  const dataSet = [
    {
      icon: Icon1,
      title: '完备的自助服务能力',
      text: '龙蜥开发者服务平台提供业界最完备的自助服务体系，覆盖研发全流程的自助服务系统',
    },
    {
      icon: Icon2,
      title: '简单便利参与开源社区',
      text: '开发者通过开发者服务平台可以非常方便的参与龙蜥社区的研发工作，开发者只需要提供代码，其它工作都可以在开发者服务平台完成',
    },
    {
      icon: Icon3,
      title: '高效的研发协同能力',
      text: '通过开发者服务平台可以高效的协同研发工作，包括项目与项目的工作以及研发各环节的工作',
    },
  ];


  const RowItem = ({ param, index: id })=> (
    <div key={id} className={styles.row_item} style={{ marginRight: (dataSet.length == id + 1) ? 0 : '20px'}}>
       <div className={styles.logo} style={{ top: id == 0 ? '-105px' : '-115px'}}><img src={param.icon} width={260}/></div>
       <p>{param.title}</p>
       <div className={styles.text}><span>{param.text}</span></div>
    </div>
  )


  return (
    <div className={styles.statistic_container}>
        {dataSet.map((item, i)=>
           <RowItem param={item} key={i} index={i}/>
        )}
    </div>
  );
};
